:host {
  position: relative;
}

.content {
  align-items: stretch;
  height: 100%;
}

.title {
  color: var(--chart-302-icon-buttons-titles);
}

.new-exclusion-list {
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
}

gz-push-body-layout::part(header) {
  margin-bottom: 0;
}

gz-push-body-layout[isOpen]::part(header) {
  padding-left: calc(2 * var(--spacer));
}
